function getColorImage(variant, color_option) {
  const images = variant.mappedColors
  if (images === null || images === undefined) {
    return null
  }
  const il = images.length
  for (let i = 0; i < il; i++) {
    if (images[i].id === color_option) {
      return images[i]
    }
  }
  return null
}

function getConfigurationColorOption(configuration, color_setting_id) {
  if (typeof configuration[color_setting_id] === 'object' && configuration[color_setting_id] !== null) {
    return configuration[color_setting_id]
  }
  return null
}

export { getColorImage, getConfigurationColorOption }
